import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

export const isCommandMenuOpenState = createAtomState<boolean>({
  key: 'isCommandMenuOpenState',
  defaultValue: false,
});
